import React, { useEffect, useState } from 'react';
import TNLogo from '../Constant/Icons/TamilNadu_Logo.png';
import user from '../Constant/Icons/user.svg';
import addUser from '../Constant/Icons/adduser.svg';
import linkIcon from '../Constant/Icons/link.svg';
import HandRight from '../Constant/Icons/HandPointRight.svg';
import mailIcon from '../Constant/Icons/mail.svg';
import addressIcon from '../Constant/Icons/AddressHome.svg';
import contactIcon from '../Constant/Icons/Contact.svg';
import FAQComponent from './Components/FAQComponent';
import { Link } from 'react-router-dom'
import './home.css';
import { serverUrl } from '../Constant/Static/config';
import axios from 'axios';


const Marquee = () => {
    const [width, setWidth] = useState(0);

    // Set the width of the marquee dynamically when the component mounts
    useEffect(() => {
        const updateWidth = () => {
            const marqueeElement = document.querySelector('.marquee-text');
            setWidth(marqueeElement ? marqueeElement.scrollWidth : 0);
        };

        updateWidth();
        window.addEventListener('resize', updateWidth);

        return () => window.removeEventListener('resize', updateWidth);
    }, []);

    return (
        <div className="marquee-container">
            <div className="marquee-wrapper" style={{ animationDuration: `${width / 50}s` }}>
                <div className="marquee-text">
                    <span><b>இரண்டாம் ஆண்டு  நேரடி பொறியியல்  சேர்க்கை-2026, &ensp;அழகப்ப செட்டியார் அரசு பொறியியல் மற்றும் தொழில்நுட்பக் கல்லூரி,&ensp;காரைக்குடி - 630003,&ensp;சிவகங்கை.</b></span>
                </div>
            </div>
        </div>
    );
};


function Home() {

    let rowIndex = 1;
    const [notifications, setNotifications] = useState([]);
    const [faqListItems, setFaqListItems] = useState([]);
    const [schedule, setSchedule] = useState([]);
    const [quickLinks, setQuickLinks] = useState([]);

    // useEffect(() => {
    //     const socket = new WebSocket(`ws://localhost:4000`);

    //     socket.onopen = () => {
    //         // console.log("WebSocket connected");
    //     };

    //     socket.onmessage = (event) => {
    //         if (event.data === 'reload') {
    //             // console.log('Reload signal received!');
    //             window.location.reload();
    //         }
    //     };

    //     socket.onerror = (error) => {
    //         console.error("WebSocket Error:", error);
    //         alert("Failed to connect to WebSocket server.");
    //     };

    //     socket.onclose = (event) => {
    //         // console.log("WebSocket closed:", event);
    //     };

    //     return () => {
    //         socket.close();
    //     };
    // }, []);


    const fetchNotifications = async () => {
        try {
            const response = await axios.get(`${serverUrl}/api/home/notifications`);
            setNotifications(response.data);
        } catch (error) {
            console.error('Error fetching notifications:', error);
        }
    };

    const fetchFaqs = async () => {
        try {
            const response = await axios.get(`${serverUrl}/api/home/faqs`);
            setFaqListItems(response.data);
        } catch (error) {
            console.error('Error fetching notifications:', error);
        }
    };

    const fetchSchedule = async () => {
        try {
            const response = await axios.get(`${serverUrl}/api/home/schedule`);
            setSchedule(response.data);
        } catch (error) {
            console.error('Error fetching notifications:', error);
        }
    };
    const fetchQuickLinks = async () => {
        try {
            const response = await axios.get(`${serverUrl}/api/home/quick-links`);
            setQuickLinks(response.data);
        } catch (error) {
            console.error('Error fetching notifications:', error);
        }
    };

    useEffect(() => {
        const fetchAllData = () => {
            fetchNotifications();
            fetchFaqs();
            fetchSchedule();
            fetchQuickLinks();
        };
        fetchAllData();
        const intervalId = setInterval(fetchAllData, 240000); // 5 minutes
        return () => clearInterval(intervalId);
    }, []);

    const formatDate = (date) => {
        const options = { weekday: 'short', day: 'numeric', month: 'long' };
        return new Date(date).toLocaleDateString('en-US', options);
    };

    const getMonthAndDay = (date) => {
        const d = new Date(date);
        const month = d.toLocaleString('default', { month: 'short' });
        const day = String(d.getDate()).padStart(2, '0');
        const year = d.getFullYear();
        return { month, day, year };
    };

    return (
        <div className='content' style={{ width: '100%' }}>
            <div className="header">
                <div className='logo'>
                    <a href='https://tnlea.com'>
                        <img alt='TN' src={TNLogo} width={50} height={50}></img>
                    </a>
                </div>
                <div className='header-content'>
                    <h3>GOVERNMENT OF TAMILNADU</h3>
                    <h4>DIRECTORATE OF TECHNICAL EDUCATION</h4>
                    <h4>Tamilnadu Lateral Entry Direct Second Year B.E/B.Tech., Admissions - 2026</h4>
                </div>
                <div className='profile'>
                    <a href='/login'>
                        <img src={user} alt='Login' width={50} height={50} />
                    </a>
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
                <Marquee />
            </div>
            <div className='homeContentContainer'>
                <div className='notificationContainer'>
                    <h3>Notifications</h3>
                    <div>
                        <div className='marquee'>
                            <ul style={{ width: '90%', textWrap: 'wrap' }} className='notificationList'>
                                {notifications.map((notification, index) => (
                                    <li key={notification.id} style={{ color: index == 0 || index == 1 ? "#7745ac" : "red" }}>
                                        <img src={HandRight} width={20} height={20} alt='link' />&ensp;{notification.message}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className='quickLinksContainer'>
                    <h3>Quick Links</h3>
                    <ul style={{ overflowY: 'scroll' }} className='quickLinksList'>
                        {
                            quickLinks.map((item, index) => {
                                return (<li id={index}>
                                    <img src={linkIcon} width={20} height={20} alt='link' />
                                    <a href={item.link} target='_blank'>&ensp;{item.label}</a>
                                </li>)
                            })
                        }
                        {
                        /* <li>
                            <img src={linkIcon} width={20} height={20} alt='link' />
                            <a href='/QuickLinks/LEA-2025/Sports_Counselling_List.pdf'>&ensp;Sports Persons List</a>
                        </li>
                        <li>
                            <img src={linkIcon} width={20} height={20} alt='link' />
                            <a href='/QuickLinks/LEA-2025/Exserviceman_Counselling_List.pdf'>&ensp;Ex-servicemen List</a>
                        </li>
                        <li>
                            <img src={linkIcon} width={20} height={20} alt='link' />
                            <a href='/QuickLinks/LEA-2025/Differentlyabled_Counselling_List.pdf'>&ensp;Differently Abled Persons List</a>
                        </li> 
                        <li>
                            <img src={linkIcon} width={20} height={20} alt='link' />
                            <a href='/QuickLinks/LEA-2025/listofcollegs.pdf'>&ensp;List of Colleges</a>
                        </li>
                        <li>
                            <img src={linkIcon} width={20} height={20} alt='link' />
                            <a href='/QuickLinks/LEA-2025/list_of_branches.pdf'>&ensp;List of Branches</a>
                        </li>
                        <li>
                            <img src={linkIcon} width={20} height={20} alt='link' />
                            <a href='/QuickLinks/LEA-2025/Counselling_Schedule TNLEA25.pdf'>&ensp;Counselling Schedule</a>
                        </li>
                        <li>
                            <img src={linkIcon} width={20} height={20} alt='link' />
                            <a href='/avg-calculator'>&ensp;Average Calculator</a>
                        </li>
                        <li>
                            <img src={linkIcon} width={20} height={20} alt='link' />
                            <a href='/QuickLinks/LEA-2025/Tentative Schedule.pdf'>&ensp;Tentative Schedule</a>
                        </li>
                        <li>
                            <img src={linkIcon} width={20} height={20} alt='link' />
                            <a href='/QuickLinks/LEA-2025/Previous Year (2024) cutoff - LEA 2025.pdf'>&ensp;Previous Year Cutoff</a>
                        </li>
                        <li>
                            <img src={linkIcon} width={20} height={20} alt='link' />
                            <a href='/QuickLinks/LEA-2025/General Information to Candidates (English)- LEA 2025.pdf'>&ensp;General Information - English</a>
                        </li>
                        <li>
                            <img src={linkIcon} width={20} height={20} alt='link' />
                            <a href='/QuickLinks/LEA-2025/Instruction to candidates - Tamil.pdf'>&ensp;Instruction to candidates - Tamil</a>
                        </li>
                        <li>
                            <img src={linkIcon} width={20} height={20} alt='link' />
                            <a href='/QuickLinks/LEA-2025/Instruction to candidates - English.pdf'>&ensp;Instruction to candidates - English</a>
                        </li>
                         <li>
                            <img src={linkIcon} width={20} height={20} alt='link' />
                            <a href='/QuickLinks/LEA-2025/SP_FORM.pdf'>&ensp;Eminent Sports Person - Certificate</a>
                        </li>
                        <li>
                            <img src={linkIcon} width={20} height={20} alt='link' />
                            <a href='/QuickLinks/LEA-2025/ESM_FORM.pdf'>&ensp;Ex-Service Man - Certificate</a>
                        </li>
                        <li>
                            <img src={linkIcon} width={20} height={20} alt='link' />
                            <a href='/QuickLinks/LEA-2025/DA_FORM.pdf'>&ensp;Differently Abled - Certificate</a>
                        </li> 

                       <li>
                            <img src={linkIcon} width={20} height={20} alt='link' />
                            <a href='#'>&ensp;List of Colleges with Branches</a>
                        </li> 
                        <li>
                            <img src={linkIcon} width={20} height={20} alt='link' />
                            <a href='#'>&ensp;Previous Year Cut-Off</a>
                        </li> */}

                    </ul>
                </div>
            </div>
            <div className="announcementContainer">
                <h3>Latest Updates</h3>

                <div className="announcementContent">
                    <h4>
                        விண்ணப்பதாரர்களின் கனிவான கவனத்திற்கு:
                    </h4>
                    <p>
                        TNLEA–2026 தரவரிசைப் பட்டியல் தொடர்பான குறைதீர்ப்பு மனுக்களை சமர்ப்பிக்கும் காலக்கெடு 18.07.2026 மாலை 5.00 மணி வரை நீட்டிக்கப்பட்டுள்ளது. மேலும், தரவரிசைப் பட்டியல் DOTE மற்றும் தன்னாட்சி பாலிடெக்னிக் கல்லூரிகளிடமிருந்து பெறப்பட்ட அனைத்து பருவங்களின் மொத்த மதிப்பெண்களின் அடிப்படையில் கணக்கிடப்பட்ட சதவீதத்தின்படி தயாரிக்கப்பட்டுள்ளது; CGPA அடிப்படையில் அல்ல என்பது மீண்டும் தெரிவித்துக் கொள்ளப்படுகிறது.
                    </p>
                </div>
            </div>
            <div className='homeContentContainer1'>
                <div>
                    <a href='/login'>
                        <img src={user} alt='User Login' width={50} height={50} />
                        <h4>User Login</h4>
                    </a>
                </div>
                {/* <div>
                <a href='/register'>
                        <img src={addUser} alt='User Registration' width={50} height={50} />
                        <h4>New Registration</h4>
                    </a>
                </div>  */}
                {/* <div>
                    <Link to="/login" state={{ loginType: 'special' }}>
                        <img src={user} alt="Specialcounselling Allotment" width={50} height={50} />
                        <h4>Specialcounselling Allotment</h4>
                    </Link>
                </div> */}
                {/* <div>
                    <a href='https://admission.tnlea.com/login'>
                        <img src={user} alt='Supplymentary Counselling' width={50} height={50} />
                        <h4>Supplementary Counselling</h4>
                    </a>
                </div> */}
            </div>
            <div className='homeContentContainerThree'>
                <div className="schedule-container">
                    <h2>TENTATIVE COUNSELLING SCHEDULE</h2>
                    <div className="event-list">
                        <div className="event-item">
                            <div className="event-date">

                                <div className="day">FROM</div>
                            </div>
                            <div className="event-detail">
                                <h4>EVENT NAME <br />
                                    <span style={{ color: '#ff4d4d' }}>&#40;நிகழ்வு&#41;</span>
                                </h4>
                            </div>
                            <div className="event-end">

                                <div className="day">TO</div>
                            </div>
                        </div>
                        {schedule.map((item, index) => {
                            const start = getMonthAndDay(item.startDate);
                            const end = getMonthAndDay(item.endDate);
                            return (
                                <div key={index} className="event-item">
                                    <div className="event-date">
                                        <div className="month">{start.year}</div>
                                        <div className="day">{start.day} {start.month}</div>
                                    </div>
                                    <div className="event-detail">
                                        <h4>{item.event} <br />
                                            <span style={{ color: '#ff4d4d' }}>({item.eventTamil})</span>
                                        </h4>
                                    </div>
                                    <div className="event-end">
                                        <div className="month">{end.year}</div>
                                        <div className="day">{end.day} {end.month}</div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>

            </div>
            <div className="homeContentContainerThree">
                <div className='faqContainer'>
                    <h3>FAQ's</h3>
                    <FAQComponent faqListItems={faqListItems} />
                </div>
            </div>
            <div className="home-footer">
                <div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', color: '#1C274C' }}>
                        <img src={mailIcon} width={20} height={20} alt='Mail' />
                        <b>&ensp;Email ID</b>
                    </div>
                    <b>&ensp;tnleaacgcet2026@gmail.com</b>
                </div>
                <div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', color: '#1C274C' }}>
                        <img src={addressIcon} width={20} height={20} alt='Address' />
                        <b>&ensp;Address</b>
                    </div>

                    <b>&ensp;Alagappa Chettiar Government College of Engineering & Technology,<br />College Road, Karaikudi - 630003, Sivagangai District</b>
                </div>
                <div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', color: '#1C274C' }}>
                        <img src={contactIcon} width={20} height={20} alt='Contact' />
                        <b>&ensp;Contact Us</b>
                    </div>
                    <b>&ensp;9843294135, 04565-230801</b>
                </div>
            </div>
        </div>
    )
}


export default Home;